<script setup lang="ts">
import logoSvg from '@/assets/logo.svg';

/**
 * App logo — imported from favicon.svg. Uses currentColor so it adapts to theme.
 */
withDefaults(defineProps<{ size?: number }>(), { size: 22 });
</script>

<template>
  <img
    :src="logoSvg"
    :width="size"
    :height="size"
    aria-label="Escherllate"
    class="app-logo"
  />
</template>

<style scoped>
.app-logo {
  color: var(--text-primary);
  display: block;
}
</style>
